import React, { useState, useEffect } from "react";
import { useDisclosure, useToast } from "@chakra-ui/react";
import {
  Box,
  Button,
  Text,
  Stack,
  Flex,
  Checkbox,
  Icon,
  IconButton,
  Heading,
  Select,
  Grid,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  FormControl,
  FormLabel,
  Input,
  SimpleGrid,
  Textarea,
  CheckboxGroup,
} from "@chakra-ui/react";
import {
  FaSync,
  FaPrint,
  FaPlus,
  FaEdit,
  FaHeading,
  FaEnvelope,
  FaCalendarTimes,
  FaCalendarCheck,
  FaUsers,
} from "react-icons/fa";
import { EditIcon, DeleteIcon } from "@chakra-ui/icons";
import { InfoOutlineIcon } from "@chakra-ui/icons";
import { Divider } from "@chakra-ui/react"; // Ensure to import the Divider component
import { Link } from "react-router-dom";
import { BASE_URL } from "../../../Globalapi/Globalapi";

const Notice = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isDeleteModalOpen,
    onOpen: onOpenDeleteModal,
    onClose: onCloseDeleteModal,
  } = useDisclosure();
  const toast = useToast();
  const [formData, setFormData] = useState({
    title: "",
    message: "",
    user_types: [],
    posted_by: 1,
    notice_date: "",
    publish_on: "",
  });

  const [notices, setNotices] = useState([]);
  const [editNoticeId, setEditNoticeId] = useState(null);
  // const [hoveredNotice, setHoveredNotice] = useState(null);
  const [deleteNoticeId, setDeleteNoticeId] = useState(null);

  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedNotice, setSelectedNotice] = useState(null);
  const {
    isOpen: isDetailModalOpen,
    onOpen: onOpenDetailModal,
    onClose: onCloseDetailModal,
  } = useDisclosure();

  useEffect(() => {
    fetchNotices();
  }, []);

  const fetchNotices = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}/admin/notice_board/list_notice_board.php`
      );
      const data = await response.json();
      setNotices(data);
    } catch (error) {
      console.error("Error fetching notices:", error);
    }
  };
  const capitalizeWords = (str) => {
    return str
      .split(" ") // Split the string into words
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize the first letter of each word
      .join(" "); // Join the words back into a string
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleCheckboxChange = (value) => {
    setFormData((prev) => ({ ...prev, user_types: value }));
  };

  const handleSubmit = async () => {
    const url = editNoticeId
      ? `${BASE_URL}/admin/notice_board/edit_notice_board.php`
      : `${BASE_URL}/admin/notice_board/create_notice_board.php`;
    console.log(editNoticeId);

    const dataToSend = editNoticeId
      ? { ...formData, notice_id: editNoticeId }
      : { ...formData, pass: sessionStorage.getItem("user_id") };
    console.log(dataToSend);

    try {
      const response = await fetch(url, {
        method: editNoticeId ? "PUT" : "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(dataToSend),
      });
      const result = await response.json();

      if (result.success) {
        toast({
          title: "Success",
          description: "Notice submitted successfully!",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
        onClose();
        resetForm();
        fetchNotices();
      } else {
        toast({
          title: "Error",
          description: response.data.message || "Failed to submit Notice!",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
        alert(`Failed to save notice: ${result.message || "Unknown error"}`);
      }
    } catch (error) {
      alert(`Error saving notice: ${error.message || "Unknown error"}`);
    }
  };

  const resetForm = () => {
    setEditNoticeId(null);
    setFormData({
      title: "",
      message: "",
      user_types: [],
      posted_by: 1,
      notice_date: "",
      publish_on: "",
    });
  };
  const userTypeMap = {
    3: "Student",
    1: "Admin",
    2: "Staff",
    4: "Guardian",
  };

  const handleEdit = (notice) => {
    setFormData({
      title: notice.title,
      message: notice.message,
      user_types: notice.user_types,
      posted_by: notice.posted_by,
      notice_date: notice.notice_date || "",
      publish_on: notice.publish_on || "",
    });
    setEditNoticeId(notice.id);
    onOpen();
  };

  const handleDelete = (id) => {
    setDeleteNoticeId(id);
    onOpenDeleteModal();
  };

  const confirmDelete = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}/admin/notice_board/delete_notice_board.php`,
        {
          method: "DELETE",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            notice_id: deleteNoticeId,
            pass: sessionStorage.getItem("user_id"),
          }), // Send notice ID in the request body
        }
      );
      console.log(deleteNoticeId);

      const result = await response.json();

      if (result.success) {
        toast({
          title: "Success",
          description: "Notice deleted successfully!",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
        fetchNotices();
      } else {
        toast({
          title: "Success",
          description: "Failed to delete!",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
        alert(`Failed to delete notice: ${result.message || "Unknown error"}`);
      }
    } catch (error) {
      alert(`Error deleting notice: ${error.message || "Unknown error"}`);
    } finally {
      onCloseDeleteModal();
      setDeleteNoticeId(null);
    }
  };
  const handleNoticeClick = (notice) => {
    setSelectedNotice(notice);
    onOpenDetailModal();
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString(undefined, {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  const handleAddNotice = () => {
    resetForm();
    onOpen();
  };

  const totalPages = Math.ceil(notices.length / rowsPerPage);
  const indexOfLastNotice = currentPage * rowsPerPage;
  const indexOfFirstNotice = indexOfLastNotice - rowsPerPage;
  const currentNotices = notices.slice(indexOfFirstNotice, indexOfLastNotice);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  return (
    <div style={{ backgroundColor: "#FBFBFD", height: "100vh" }}>
      <div className="teacher-list-container">
        <div className="header">
          <h1 style={{ fontSize: "20px", margin: 0 }}>Notice Board</h1>
          <div className="action-buttons">
            {/* <Button
              onClick={() => window.location.reload()}
              boxShadow="md"
              backgroundColor="white"
              fontSize="11px"
            >
              <FaSync color="#515B73" />
            </Button> */}
            {/* <Button backgroundColor="white" fontSize="11px" boxShadow="md">
              <FaPrint color="#515B73" />
              Print PDF
            </Button> */}
            <Button
              onClick={handleAddNotice}
              leftIcon={<FaPlus />}
              colorScheme="teal"
            >
              Add
            </Button>
          </div>
        </div>
        <div className="breadcrumb">
          <Link
            to="/admin"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <span>Dashboard</span>
          </Link>{" "}
          / <span>Announcement</span> / <span>Notice</span>
        </div>

        <Flex
          justify="space-between"
          align="center"
          className="sb"
          p={3}
          mt={4}
        >
          <Flex align="center">
            <Text mr={2}>Rows Per Page</Text>
            <Select
              width="100px"
              value={rowsPerPage}
              onChange={(e) => setRowsPerPage(Number(e.target.value))}
              borderColor="#E9EDF4"
            >
              <option value={10}>10</option>
              <option value={20}>20</option>
              <option value={50}>50</option>
            </Select>
            {/* <Text ml={2}>Entries</Text> */}
          </Flex>
        </Flex>
        <Box className="notice-list" overflowX="auto" mt={1} mb={1}>
          {currentNotices.length === 0 ? (
            <Text>No notices available</Text>
          ) : (
            <Grid
              templateColumns={{ base: "repeat(1, 1fr)", md: "repeat(4, 1fr)" }}
              gap={4}
            >
              {currentNotices.map((notice) => (
                <Box
                  key={notice.id}
                  p={2}
                  shadow="md"
                  borderWidth="1px"
                  borderRadius="lg"
                  backgroundColor="white"
                  _hover={{ boxShadow: "lg", backgroundColor: "#f9f9f9" }}
                >
                  <Flex justify="space-between" align="start">
                    {/* Left Section (Checkbox, Notice Icon, and Heading) */}
                    <Flex align="start" mr={2} width="100%">
                      <Checkbox mt={1} />
                      <Icon
                        as={InfoOutlineIcon}
                        boxSize={4}
                        mr={4}
                        ml={1}
                        mt={1}
                      />
                      <Box mt={1} flex="1" minWidth="0">
                        {/* Truncated Heading */}
                        <Heading
                          fontSize="xs"
                          onClick={() => handleNoticeClick(notice)}
                          style={{
                            cursor: "pointer",
                            whiteSpace: "nowrap", // Prevent wrapping
                            overflow: "hidden", // Hide overflow text
                            textOverflow: "ellipsis", // Add ellipsis
                            maxWidth: "200px", // Set a max width for the title
                          }}
                        >
                          {capitalizeWords(notice.title)}
                        </Heading>
                        {/* Created On */}
                        {notice.created_at && (
                          <Text
                            fontSize="xs"
                            color="gray.500"
                            ml={0}
                            noOfLines={1}
                          >
                            Created on: {formatDate(notice.created_at)}
                          </Text>
                        )}
                      </Box>
                    </Flex>

                    {/* Right Section (Edit and Delete Icons) */}
                    <Flex align="start" justify="center">
                      <IconButton
                        aria-label="Edit notice"
                        icon={<EditIcon />}
                        size="xs" // Reduced size to "xs"
                        mr={2} // Added margin to separate icons horizontally
                        onClick={() => handleEdit(notice)}
                        _hover={{ bg: "blue.200", color: "white" }}
                      />
                      <IconButton
                        aria-label="Delete notice"
                        icon={<DeleteIcon />}
                        size="xs" // Reduced size to "xs"
                        colorScheme="red"
                        onClick={() => handleDelete(notice.id)}
                        _hover={{ bg: "red.200", color: "white" }}
                      />
                    </Flex>
                  </Flex>
                </Box>
              ))}
            </Grid>
          )}
        </Box>

        <Flex justify="end" align="center" className="sb2" p={3}>
          <Button
            onClick={() => handlePageChange(currentPage - 1)}
            isDisabled={currentPage === 1}
          >
            Prev
          </Button>

          <Stack direction="row" spacing={2} mx={2}>
            {Array.from({ length: totalPages }, (_, i) => (
              <Button
                key={i}
                onClick={() => handlePageChange(i + 1)}
                colorScheme={currentPage === i + 1 ? "teal" : "gray"}
              >
                {i + 1}
              </Button>
            ))}
          </Stack>

          <Button
            onClick={() => handlePageChange(currentPage + 1)}
            isDisabled={currentPage === totalPages}
          >
            Next
          </Button>
        </Flex>
      </div>

      {/* Notice Modal */}
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        size="lg"
        motionPreset="slideInBottom"
      >
        <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(10px)" />
        <ModalContent
          borderRadius="lg"
          boxShadow="xl"
          bg="linear-gradient(135deg, #e0f7f7, #f0ffff)"
          color="gray.700"
          p={6}
          maxW="700px"
          maxH="550px"
          overflowY="auto"
        >
          <ModalHeader
            fontSize="xl"
            fontWeight="bold"
            textAlign="center"
            color="teal.600"
          >
            <Icon as={editNoticeId ? FaEdit : FaPlus} boxSize={5} mr={2} />
            {editNoticeId ? "Edit Notice" : "Create Notice"}
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody
            overflowY="auto"
            px={4}
            css={{
              "&::-webkit-scrollbar": {
                width: "6px",
              },
              "&::-webkit-scrollbar-track": {
                background: "rgba(255, 255, 255, 0.2)",
                borderRadius: "10px",
                backdropFilter: "blur(8px)",
              },
              "&::-webkit-scrollbar-thumb": {
                background: "rgba(173, 216, 230, 0.6)",
                borderRadius: "10px",
                backdropFilter: "blur(8px)",
              },
              "&::-webkit-scrollbar-thumb:hover": {
                background: "rgba(173, 216, 230, 0.9)",
              },
            }}
          >
            <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
              <FormControl mb={4}>
                <FormLabel>
                  {" "}
                  <Icon as={FaHeading} mr={1} color="teal.500" />
                  Title
                </FormLabel>
                <Input
                  name="title"
                  bg="white"
                  _hover={{ borderColor: "teal.300" }}
                  value={formData.title}
                  onChange={handleFormChange}
                  placeholder="Enter the title"
                  required
                />
              </FormControl>
              <FormControl mb={4}>
                <FormLabel>
                  {" "}
                  <Icon as={FaEnvelope} mr={1} color="teal.500" />
                  Message
                </FormLabel>
                <Textarea
                  name="message"
                  bg="white"
                  _hover={{ borderColor: "teal.300" }}
                  value={formData.message}
                  onChange={handleFormChange}
                  placeholder="Enter your message"
                  required
                />
              </FormControl>
              <FormControl mb={4}>
                <FormLabel>
                  {" "}
                  <Icon as={FaCalendarTimes} mr={1} color="teal.500" />
                  Expiry Date
                </FormLabel>
                <Input
                  type="date"
                  bg="white"
                  _hover={{ borderColor: "teal.300" }}
                  name="notice_date"
                  value={formData.notice_date}
                  onChange={handleFormChange}
                />
              </FormControl>
              <FormControl mb={4}>
                <FormLabel>
                  {" "}
                  <Icon as={FaCalendarCheck} mr={1} color="teal.500" />
                  Published On
                </FormLabel>
                <Input
                  type="date"
                  bg="white"
                  _hover={{ borderColor: "teal.300" }}
                  name="publish_on"
                  value={formData.publish_on}
                  onChange={handleFormChange}
                />
              </FormControl>
              <FormControl mb={4}>
                <FormLabel>
                  {" "}
                  <Icon as={FaUsers} mr={1} color="teal.500" />
                  Message To
                </FormLabel>
                <CheckboxGroup
                  colorScheme="green"
                  value={formData.user_types}
                  onChange={handleCheckboxChange}
                >
                  <Stack spacing={5} direction="row">
                    <Checkbox value="3">Student</Checkbox>
                    <Checkbox value="1">Admin</Checkbox>
                    <Checkbox value="2">Staff</Checkbox>
                    <Checkbox value="4">Guardian</Checkbox>
                  </Stack>
                </CheckboxGroup>
              </FormControl>
            </SimpleGrid>
          </ModalBody>
          <ModalFooter>
            <Button
              bgGradient="linear(to-r, teal.400, teal.600)"
              color="white"
              _hover={{ bgGradient: "linear(to-r, teal.500, teal.700)" }}
              mr={3}
              onClick={handleSubmit}
            >
              Save
            </Button>
            {/* <Button variant="ghost" onClick={onClose}>
              Cancel
            </Button> */}
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* Delete Confirmation Modal */}
      <Modal isOpen={isDeleteModalOpen} onClose={onCloseDeleteModal}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Delete Notice</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text>Are you sure you want to delete this notice?</Text>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="red" onClick={confirmDelete}>
              Delete
            </Button>
            <Button onClick={onCloseDeleteModal} ml={3}>
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      {/* Modal for notice details */}
      <Modal isOpen={isDetailModalOpen} onClose={onCloseDetailModal} size="lg">
        <ModalOverlay />
        <ModalContent maxW="750px">
          <ModalHeader>Notice Details</ModalHeader>
          <Divider /> {/* Divider under Notice Details */}
          <ModalCloseButton />
          <ModalBody>
            {selectedNotice && (
              <>
                <Text fontWeight="bold">
                  {capitalizeWords(selectedNotice.title)}
                </Text>{" "}
                {/* Capitalizing the notice title */}
                <Text mt={2}>
                  {capitalizeWords(selectedNotice.message)}
                </Text>{" "}
                {/* Capitalizing the message */}
                <Box mt={4}>
                  <Flex justify="space-between" alignItems="flex-start" mb={2}>
                    {selectedNotice.notice_date && (
                      <Box>
                        {" "}
                        {/* Notice Date on the left */}
                        <Text fontSize="sm" fontWeight="bold" color="black">
                          Expiry Date
                        </Text>
                        <Text fontSize="sm" color="gray.500">
                          {formatDate(selectedNotice.notice_date)}
                        </Text>
                      </Box>
                    )}
                    {selectedNotice.publish_on && (
                      <Flex justify="flex-end" alignItems="flex-start" mb={2}>
                        {" "}
                        {/* Aligns to the right, but keeps it closer */}
                        <Box>
                          {" "}
                          {/* Keeping the box for the labels */}
                          <Text fontSize="sm" fontWeight="bold" color="black">
                            Publish On
                          </Text>
                          <Text fontSize="sm" color="gray.500">
                            {formatDate(selectedNotice.publish_on)}
                          </Text>
                        </Box>
                      </Flex>
                    )}
                  </Flex>
                </Box>
                {/* Divider above Message To */}
                <Divider my={4} />
                {selectedNotice.user_types &&
                  selectedNotice.user_types.length > 0 && (
                    <>
                      <Text
                        fontSize="sm"
                        color="black"
                        fontWeight="bold"
                        mb={2}
                      >
                        Message To
                      </Text>
                      <Flex direction="row" spacing={2} wrap="wrap">
                        {" "}
                        {/* Change to row and enable wrapping */}
                        {selectedNotice.user_types.map((type, index) => (
                          <Box
                            key={index}
                            p={2}
                            bg="teal.100"
                            borderRadius="md"
                            mr={2} // Margin right to separate boxes
                            mb={2} // Margin bottom for spacing when wrapped
                          >
                            <Text fontSize="sm" color="teal.600">
                              {userTypeMap[type]}
                            </Text>
                          </Box>
                        ))}
                      </Flex>
                    </>
                  )}
                {/* Divider below Message To */}
                <Divider my={4} />
              </>
            )}
          </ModalBody>
          <ModalFooter>
            <Button
              colorScheme="teal"
              variant="ghost"
              onClick={onCloseDetailModal}
            >
              Close
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </div>
  );
};

export default Notice;
